import { render, staticRenderFns } from "./not-satisfied.vue?vue&type=template&id=72e529dc&scoped=true&"
import script from "./not-satisfied.vue?vue&type=script&lang=js&"
export * from "./not-satisfied.vue?vue&type=script&lang=js&"
import style0 from "./not-satisfied.vue?vue&type=style&index=0&id=72e529dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e529dc",
  null
  
)

export default component.exports